import styled from "styled-components";
import { tokens } from "./UI";

const Bold = styled.strong`
  font-weight: ${tokens.fontWeight.fw9};
`;

export default Bold;
